import Page from '../../components/Page';

export default () => {
    return <Page title="Gebiete">

    </Page>
}